export default function () {
	return {
		countries: [],
		country: null,
		courses: []
	}
}
